import React from 'react';
import {useTranslation} from 'react-i18next';
import {Modal} from 'antd-mobile';
import {InviteRechargeRule} from '../../agent.type';
import RewardRulesList from './reward-rules-list';
import {CloseIcon} from '@/common-pages/proxy/svg.variable';

interface RewardRulesModalProps {
  visible: boolean;
  onClose: () => void;
  rewardRules: InviteRechargeRule[];
}

const RewardRulesModal: React.FC<RewardRulesModalProps> = ({
  visible,
  onClose,
  rewardRules,
}) => {
  const {t} = useTranslation();
  return (
    <Modal
      visible={visible}
      onClose={onClose}
      bodyClassName="w-[21.9375rem] !pt-0 [&_.adm-modal-content]:p-0 bg-transparent"
      content={
        <div className="bg-white rounded-[1.5rem] overflow-hidden">
          {/* 顶部标题栏 */}
          <div className="flex items-center justify-between pt-5 px-5 pb-3">
            <h3 className="font-bold text-base text-t1">
              {t('agent.invitation-reward.saleRules')}
            </h3>
            <button
              onClick={onClose}
              className="flex items-center justify-center size-6 rounded-full hover:bg-gray-100 transition-colors">
              <CloseIcon className="size-6 text-t3" />
            </button>
          </div>

          {/* 内容区域 */}
          <div className="px-5 pb-3">
            <RewardRulesList rewardRules={rewardRules} />
          </div>
        </div>
      }
    />
  );
};

export default RewardRulesModal;
